import { useEffect, useState } from 'react';

export function useViewport(breakpoint: number) {
    const [mounted, setMounted] = useState(false);
    const [vw, setVw] = useState<number | null>(null);

    useEffect(() => {
        setMounted(true);

        const setWidth = () => setVw(window.innerWidth);
        setWidth();

        const mql = window.matchMedia(`(max-width:${breakpoint}px)`);
        const onChange = () => setVw(window.innerWidth);

        if (mql.addEventListener) mql.addEventListener('change', onChange);
        else mql.addListener(onChange);

        window.addEventListener('resize', setWidth);

        return () => {
            if (mql.removeEventListener) mql.removeEventListener('change', onChange);
            else mql.removeListener(onChange);
            window.removeEventListener('resize', setWidth);
        };
    }, [breakpoint]);

    const isMobile = vw !== null && vw <= breakpoint;

    return { mounted, vw, isMobile };
}

